import React from 'react';

import {
  Icon,
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';
import Links from './Links';

const BlockStyle = ({
  editorState,
  onLink,
  onToggle,
}) => {
  const BLOCK_TYPES = [
    {
      icon: 'fas fa-list-ul',
      style: 'unordered-list-item',
      tooltip: 'Unordered list (Tab)',
    },
    {
      icon: 'fas fa-list-ol',
      style: 'ordered-list-item',
      tooltip: 'Ordered list',
    },
  ];

  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  const Blocks = BLOCK_TYPES.map(type => (
    <Tooltip
      key={type.style}
      body={type.tooltip}
      preferPlace="above"
    >
      <S.Control
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onToggle(type.style);
        }}
        isActive={type.style === blockType}
      >
        <Icon type={type.icon} />
      </S.Control>
    </Tooltip>
  ));

  return (
    <Flex spacing={10}>
      {Blocks}
      <Links onLink={onLink} />
    </Flex>
  );
};

export default BlockStyle;
